import {
  FETCH_CONFIGURATIONS,
  DELETE_CONFIGURATION,
  UPDATE_CONFIGURATION,
  CREATE_CONFIGURATION,
  SET_CONFIGURATIONS_FILTER,
} from './actionTypes'
import api from 'utils/api'

export const fetchConfigurations = (currentVenueId, config) => (dispatch) =>
  api
    .fetchConfigurations(currentVenueId, config)
    .then(({ data }) => dispatch(fetchConfigurationsAction(data)))

export const deleteConfiguration = (uuid, config) => (dispatch) =>
  api
    .deleteConfiguration(uuid, config)
    .then(({ data }) => dispatch(deleteConfigurationAction(data)))

export const updateConfiguration = (payload, config) => (dispatch) =>
  api
    .updateConfiguration(payload, config)
    .then(({ data }) => dispatch(updateConfigurationAction(data)))

export const createConfiguration = (payload, config) => (dispatch) =>
  api
    .createConfiguration(payload, config)
    .then(({ data }) => dispatch(createConfigurationAction(data)))

export const fetchConfigurationsAction = (configurations) => ({
  type: FETCH_CONFIGURATIONS,
  payload: configurations,
})

export const deleteConfigurationAction = (configuration) => ({
  type: DELETE_CONFIGURATION,
  payload: configuration,
})

export const updateConfigurationAction = (configuration) => ({
  type: UPDATE_CONFIGURATION,
  payload: configuration,
})

export const createConfigurationAction = (configuration) => ({
  type: CREATE_CONFIGURATION,
  payload: configuration,
})

export const setConfigurationFilter = (payload) => ({
  type: SET_CONFIGURATIONS_FILTER,
  payload,
})
